<app-navbar></app-navbar>
<!-- slider -->
<section class="about-us-slider swiper-container p-relative">
    <div class="swiper-wrapper">
        <div class="swiper-slide slide-item">
            <img src="assets/img/about/blog/1920x700/banner-8.webp" class="img-fluid full-width" alt="Banner">
            <div class="transform-center">
                <div class="container">
                    <div class="row justify-content-start">
                        <div class="col-lg-7 align-self-start">
                            <div class="right-side-content">
                                <h1 class="text-custom-white fw-600">Hey Burgerians!!!</h1>
                                <h3 class="text-custom-white fw-400">A Burger a Day 
                                    </h3>
                                    <h3 class="text-custom-white fw-400">Keeps the Bland Away 
                                    </h3>
                                <!-- <a routerLink="/restaurant" class="btn-second btn-submit">Learn More.</a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overlay "></div>
        </div>
        <div class="swiper-slide slide-item">
            <img src="assets/img/about/blog/1920x700/banner-9.webp" class="img-fluid full-width" alt="Banner">
            <div class="transform-center">
                <div class="container">
                    <div class="row justify-content-end">
                        <div class="col-lg-8 align-self-end">
                            <div class="right-side-content text-end">
                                <h1 class="text-custom-white fw-600">We are Burgerians, </h1>
                                <h3 class="text-custom-white fw-400">We believe in Burgers</h3>
                                <!-- <a routerLink="/restaurant" class="btn-second btn-submit">Learn More.</a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overlay "></div>
        </div>
        <div class="swiper-slide slide-item">
            <img src="assets/img/about/blog/1920x700/banner-6.webp" class="img-fluid full-width" alt="Banner">
            <div class="transform-center">
                <div class="container">
                    <div class="row justify-content-end">
                        <div class="col-lg-7 align-self-end">
                            <div class="right-side-content text-left">
                                <h1 class="text-custom-white fw-600">Ready for a Mouth-Watering Meltdown</h1>
                                <h3 class="text-custom-white fw-400"> </h3>
                                <!-- <a routerLink="/restaurant" class="btn-second btn-submit">Learn More.</a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overlay "></div>
        </div>
    </div>
    <!-- Add Arrows -->
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
</section>
    <!-- slider -->
    <!-- about us -->
    <section class="aboutus section-padding">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="history-title mb-md-40">
                        <h2 class="text-light-black "> <span class="text-light-green">About Us</span></h2>
                        <p class="text-light-white">Inspired by the West Coast culinary pioneers, our burger creations are extraordinary innovations. Our burger masters dedicate their days to delicious feats, crafting wonders.</p>
                        <p class="text-light-white">We believe in the Burgerian way of life. It's a philosophy centered around the pure joy and satisfaction that comes from a perfectly crafted burger. It's about the satisfaction that fills you with each juicy bite, the chorus of deliciousness that erupts in your mouth. It's about the community that gathers around the heart of the burger, sharing laughter and good times, united by their love for this all-American patty.</p> 
            <p class="text-light-white">We are proud to say that we offer all of your burger and shake favorites, all of which are locally owned and operated. Once you try our delicious items, we know you will be coming back for more!</p>

                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-sm-6 col-md-6">
                            <div class="histry-img mb-xs-20">
                                <img src="assets/img/about/blog/255x200/melted-cheese-burger.webp" class="img-fluid full-width" alt="Histry">
                            </div>
                        </div>
                        <div class="col-lg-6 col-sm-6 col-md-6">
                            <div class="histry-img mb-xl-20">
                                <img src="assets/img/about/blog/255x200/About-section-img.jpg" class="img-fluid full-width" alt="Histry">
                            </div>
                            <div class="histry-img">
                                <img src="assets/img/about/blog/255x200/about-section-2.jpg" class="img-fluid full-width" alt="Histry">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="aboutus">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-sm-6 col-md-6">
                            <div class="histry-img mb-xs-20">
                                <img src="assets/img/about/blog/255x200/burger.jpg" class="img-fluid full-width" alt="Histry">
                            </div>
                        </div>
                        <div class="col-lg-6 col-sm-6 col-md-6">
                            <div class="histry-img mb-xl-20">
                                <img src="assets/img/about/blog/255x200/BurgerKing.jpg" class="img-fluid full-width" alt="Histry">
                            </div>
                            <div class="histry-img">
                                <img src="assets/img/about/blog/255x200/special_burger.jpg" class="img-fluid full-width" alt="Histry">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="history-title mb-md-40">
                        <h2 class="text-light-black mt-4">
                            <span class="text-light-green">Why Choose Us?</span>
                        </h2>
                
                        <ul class="text-light-white why-choose-list">
                            <li><strong>Quality Ingredients:</strong> Locally sourced, ensuring every bite is an unforgettable experience.</li>
                            <li><strong>Unique Flavors:</strong> Our proprietary blend of spices and creative toppings make each burger a pure delight.</li>
                            <li><strong>Quality Commitment:</strong> We thrive in delivering the best experience, with every meal prepared to perfection.</li>
                            <li><strong>Community Spirit:</strong> We are locally owned and operated, proud to be a part of the neighborhood.</li>
                        </ul>
                        <h2 class="text-light-black">
                            <span class="text-light-green">Our Mission

                            </span>
                        </h2>
                
                        <p class="text-light-white">To deliver an exceptional dining experience with high-quality, flavorful burgers reminiscent of those found on the streets of Los Angeles. </p>
                        <p class="text-light-white">We strive to introduce the Australian market to the excitement of classic American milkshakes, a distinctive feature rarely seen in the local dining scene.</p> 
                    </div>
                </div>
                
                
            </div>
        </div>
    </section>
    <!-- about us -->
    <!-- How It Woks -->
    <!-- <section class="section-padding how-it-works bg-light-theme">
        <div class="container">
            <div class="section-header-style-2">
                <h6 class="text-light-green sub-title">Our Process</h6>
                <h3 class="text-light-black header-title">How Does It Work</h3>
            </div>
            <div class="row">
                <div class="col-lg-3 col-sm-6">
                    <div class="how-it-works-box arrow-1">
                        <div class="how-it-works-box-inner"> <span class="icon-box">
                <img src="assets/img/001-search.png" alt="icon">
                <span class="number-box">01</span>
                            </span>
                            <h6>Search</h6>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                    <div class="how-it-works-box arrow-2">
                        <div class="how-it-works-box-inner"> <span class="icon-box">
                <img src="assets/img/004-shopping-bag.png" alt="icon">
                <span class="number-box">02</span>
                            </span>
                            <h6>Select</h6>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                    <div class="how-it-works-box arrow-1">
                        <div class="how-it-works-box-inner"> <span class="icon-box">
                <img src="assets/img/002-stopwatch.png" alt="icon">
                <span class="number-box">03</span>
                            </span>
                            <h6>Order</h6>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                    <div class="how-it-works-box">
                        <div class="how-it-works-box-inner"> <span class="icon-box">
                <img src="assets/img/003-placeholder.png" alt="icon">
                <span class="number-box">04</span>
                            </span>
                            <h6>Enjoy</h6>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <!-- How It Woks -->
    <!-- blog and advertisement -->
    <section class="section-padding our-blog restaurent-ad">
        <div class="container">
            <!-- <div class="section-header-style-2">
                <h6 class="text-light-green sub-title">Our Blog</h6>
                <h3 class="text-light-black header-title">Latest News</h3>
            </div> -->
            <div class="row">
                <div class="col-md-12">
                    <div class="blog-box mb-xl-20">
                        <article class="post">
                            <div class="blog-img p-relative">
                                <a href="#">
                                    <img src="assets/img/about/blog/740x442/blog-1.jpg" alt="blog-img">
                                </a>
                                <!-- <div class="overlay padding-20">
                                    <div class="blog-meta">
                                        <h4 class="text-custom-white mb-2 fw-600">New locations where you can now get your Quickmunch® delivered</h4>
                                        <a routerLink="/blog-details" class="text-custom-white fw-700 fs-18">Read More</a>
                                    </div>
                                </div> -->
                                <div class="overlay "></div>
                            </div>
                        </article>
                        <div class="side-blog padding-20 u-line">
                            <div class="entry-meta-content">
                                <div class="entry-tye"> <h5 class="text-light-green fw-600">Connect With Us
                                </h5>
                                </div>
                            </div>
                            <h6 class="entry-title no-margin">
                                <p  class="text-light-white">We believe in fresh, high-quality ingredients, stacked high to create a burger so good, it's a sensation! Our burgers are made with Australian beef and cooked to perfection. Each patty is served on a yummy bun and topped with the classic fixings: crisp lettuce, juicy tomato, savory onion, and melted cheese.</p>
                            </h6>
                            <div class="entry-meta-content mt-1">
                                <div class="entry-tye"> <h5 class="text-light-green fw-600">Our Vision
                                </h5>
                                </div>
                            </div>
                            <h6 class="entry-title no-margin">
                                <p  class="text-light-white">To be the preferred destination for burger enthusiasts in Australia, offering a unique blend of American flavors with a touch of LA's laid-back charm. We aim to create a welcoming atmosphere where everyone feels like a part of the Burgerian community.</p>
                            </h6>
                        </div>
                    </div>
                    <!-- <div class="ad-img p-relative">
                        <img src="assets/img/about/blog/1110x350/hbanner-1.jpg" class="img-fluid full-width" alt="#">
                        <div class="overlay">
                            <div class="content-box transform-center">
                                <p class="text-custom-white">Quickmunch</p>
                                <h3 class="text-custom-white mb-1">More than 3000 restaurants</h3>
                                <h5 class="text-custom-white">Book a table easly at the best price</h5>
                                <a routerLink="/restaurant" class="btn-first white-btn">View All</a>
                            </div>
                        </div>
                        <div class="overlay "></div>
                    </div> -->
                </div>
            </div>
        </div>
    </section>
    <!-- blog and advertisement -->
    <!-- feedback -->
    <section class="feedback-area-two section-padding">
        <div class="container">
            <div class="section-header-style-2">
                <h6 class="text-light-green sub-title">Testimonials</h6>
                <h3 class="text-custom-white header-title">People Say About Us!</h3>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="feedback-slider p-relative swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="feedback-item-two">
                                    <img src="assets/img/about/72x72/user-1.png" alt="Feedback">
                                    <p class="text-custom-white fs-16">I like Quickmunch and as compared to other company it's polices and customers support is very good easy to reach., also many time they unable to delivered. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisist amet, sed do eiusm.</p>
                                    <h4 class="text-custom-white fw-600 no-margin">Janadhon doe</h4>
                                    <!-- <span class="text-custom-white fw-600">Co-founder</span> -->
                                </div>
                            </div>
                        </div>
                        <!-- Add Arrows -->
                        <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- feedback -->
    <app-footer1></app-footer1>